import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { List, Paper, Typography, CircularProgress } from "@material-ui/core";
import {
  RowDetailState,
  PagingState,
  IntegratedPaging,
  SearchState,
  IntegratedFiltering,
  CustomPaging,
} from "@devexpress/dx-react-grid";
import {
  Grid as DataGrid,
  Table,
  TableHeaderRow,
  TableRowDetail,
  PagingPanel,
  Toolbar,
  SearchPanel,
} from "@devexpress/dx-react-grid-material-ui";
import { Dashboard as DashboardLayout } from "layouts";
import { withStyles } from "@material-ui/core";
import styles from "theme/skin";
import { useQuery } from "@apollo/client";
import WarrantyRegistrationTabs from "pages/Administration/WarrantyRegistration/WarrantyRegistrationTabs";
import {
  GET_MY_DEALERS_SALE,
  getwarrantysales,
  SALES_WARRANTY_REGISTRATION,
} from "../queries";
import { debounce } from "common/colors";
import auth from "Auth";
import "./salesWarrantyRegistration.scss";

import { CSVLink } from "react-csv";
import GridContainer from "@material-ui/core/Grid";

import CloudDownloadOutlinedIcon from "@material-ui/icons/CloudDownloadOutlined";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import Tooltip from "@material-ui/core/Tooltip";
import { Query } from "react-apollo";

const searchMessages = {
  searchPlaceholder: "Search",
};

const WarrantyRegistrations = ({ classes }) => {
  const [apolloArgs, setApolloArgs] = useState({
    page: 0,
    limit: 25,
    search: "",
  });
  const [warrantyData, setWarrantyData] = useState([]);
  const [columns] = useState([
    { name: "warranty_id", title: "#" },
    { name: "submittedon", title: "Submitted" },
    { name: "hull_identification_number", title: "HIN" },
    { name: "model", title: "Model" },
    {
      name: "admin_name",
      title: "Dealer",
      getCellValue: (row) => row?.profiles?.name || "",
    },
    { name: "status", title: "Status" },
  ]);
  const [filterBy, setFilterBy] = useState("warranty_id");
  const [pageSizes] = useState([25, 50, 100, 250, 500]);
  const [searchTerm, setSearchTerm] = useState("");
  const [profileIds, setProfileIds] = useState([]);
  const [selectedField, setSelectedField] = useState("#");
  const [searchValue, setSearchValue] = useState("");
  const [TotalWaranty, setTotalWarranty] = useState([]);

  const { loading: salesLoading, data: salesData } = useQuery(
    GET_MY_DEALERS_SALE,
    {
      notifyOnNetworkStatusChange: true,
      variables: { profile_id: auth.getSub() },
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        setProfileIds([
          ...data?.sales_assign?.map((e) => e?.assign_user_id),
          auth.getSub(),
        ]);
      },
    }
  );

  const isOnlyNumbers = (str) => {
    return /^\d+$/.test(str.trim());
  };

  const getQueryVariables = (search, filterBy) => {
    const { page, limit } = apolloArgs;
    let where = {
      status: { _neq: "Deleted" },
    };
    if (search && filterBy) {
      if (filterBy === "hull_identification_number") {
        where = {
          _or: [{ hull_identification_number: { _ilike: "%" + search + "%" } }],
        };
      } else if (filterBy === "submittedon") {
        where = {
          _or: [{ submittedon: { _eq: `%${search}%` } }],
        };
      } else if (filterBy === "warranty_id" && isOnlyNumbers(search)) {
        where = {
          _or: [
            {
              warranty_id: { _eq: parseInt(search) },
            },
          ],
        };
      } else if (filterBy === "model") {
        where = {
          _or: [{ model: { _ilike: `%${search}%` } }],
        };
      } else if (filterBy === "admin_name") {
        where = {
          _or: [{ admin_name: { _ilike: `%${search}%` } }],
        };
      } else if (filterBy === "status") {
        where = {
          _or: [{ status: { _ilike: `%${search}%` } }],
        };
      } else {
        where = {};
      }
    }
    if (profileIds?.length > 0) {
      where.profile_id = {
        _in: profileIds,
      };
    }

    return {
      skip: page * limit,
      limit,
      where,
    };
  };

  const createRowDetail = useCallback(
    (refreshWarrantyRegistrations) =>
      ({ row }) =>
        (
          <div>
            <List dense={true}>
              <WarrantyRegistrationTabs
                refreshWarrantyRegistrations={refreshWarrantyRegistrations}
                rowData={row}
                id={row?.id}
                roleType="sales"
              />
            </List>
          </div>
        ),
    []
  );

  const handleOnChange = useCallback(
    debounce((value, fun, filter) => {
      setApolloArgs((prevArgs) => ({ ...prevArgs, search: value }));
      refetch(getQueryVariables(value, filter));
    }, 1500),
    []
  );

  const changePageSize = useCallback(
    (pageSize, refetch) => {
      setApolloArgs((prevArgs) => ({ ...prevArgs, limit: pageSize }));
      const { page, limit } = apolloArgs;
      refetch({
        skip: page * limit,
      });
    },
    [apolloArgs]
  );

  const loadMoreRegistrations = useCallback(
    (currentPage, refetch, fetchMore) => {
      setApolloArgs((prevArgs) => ({ ...prevArgs, page: currentPage }));
      const { search } = apolloArgs;
      if (search) {
        refetch(getQueryVariables(apolloArgs.search, filterBy));
      } else {
        fetchMore({
          variables: getQueryVariables(apolloArgs.search, filterBy),
          updateQuery: (previousResult, { fetchMoreResult }) => {
            if (!fetchMoreResult) {
              return previousResult;
            }
            return {
              ...previousResult,
              data: fetchMoreResult?.data,
            };
          },
        });
      }
    },
    [apolloArgs, getQueryVariables]
  );

  const { data, loading, error, fetchMore, refetch } = useQuery(
    SALES_WARRANTY_REGISTRATION,
    {
      variables: getQueryVariables(apolloArgs?.search, filterBy),
      skip: salesData === undefined,
      // variables: {
      //   profileIds: [
      //     ...(salesData?.sales_assign?.map((e) => e?.assign_user_id) || []),
      //     auth.getSub(),
      //   ],
      // },
      fetchPolicy: "cache-and-network",
    }
  );
  console.log("datat=========>", data);

  console.log(error);
  useEffect(() => {
    if (data) {
      setWarrantyData(data?.warranty_registration);
    }
  }, [data]);

  const handleFieldChange = (selectedField) => {
    setSelectedField(selectedField);
    setSearchValue("");
  };

  const FieldDropdown = ({ fields, selectedField, onSelectField }) => (
    <select
      value={selectedField}
      onChange={(e) => onSelectField(e.target.value)}
    >
      {fields?.map((field) => (
        <option key={field} value={field}>
          {field}
        </option>
      ))}
    </select>
  );

  const changeSearchValue = (newValue) => {
    setSearchValue(newValue);
  };

  const handleDealerChange = (event) => {
    setSearchValue(event.target.value);
  };

  const uniqueDealers = [
    ...new Set(data?.warranty_registration?.map((row) => row?.profiles?.name)),
  ];

  const filteredRows = data?.warranty_registration?.filter((row) => {
    const columnInfo = columns.find((e) => e.title === selectedField);

    if (!columnInfo) return false;

    let cellValue;
    if (columnInfo.name === "admin_name") {
      cellValue = row?.profiles?.name || "";
    } else if (columnInfo.name === "warranty_id") {
      cellValue = String(row[columnInfo.name]);
    } else {
      cellValue = row[columnInfo.name] ?? "";
    }

    cellValue = String(cellValue).toLowerCase();
    const searchText = searchValue.toLowerCase().trim();

    return cellValue.includes(searchText);
  });

  return (
    <DashboardLayout title="Warranty Registration">
      <div className={classes.root + " sectionContainer abs"}>
        <Typography gutterBottom variant="h4" className="title">
          <span>Warranty Registrations</span>
        </Typography>

        <Query
          query={getwarrantysales}
          variables={{ profileIds: profileIds?.map((item) => item) }}
          notifyOnNetworkStatusChange={true}
          fetchPolicy="cache-and-network"
          onCompleted={(data) => {
            setTotalWarranty(data?.warranty_registration);
          }}
        >
          {({ data:salesAllData,  loading: loadingDownload, error, fetchMore, refetch }) => {
            console.log(error,"errorerror")
            // if (loadingDownload) {
            //   return (
            //     <div className="flex center" style={{ padding: "2em 0" }}>
            //       <p>Loading...</p>
            //       <CircularProgress />
            //     </div>
            //   );
            // }
            return (
              <Paper className="tableStyles" style={{ margin: "3em" }}>
                {loading || salesLoading || loadingDownload ? (
                  <div className="flex center" style={{ padding: "2em 0" }}>
                    <p>Loading...</p>
                    <CircularProgress />
                  </div>
                ) : (
                  <>
                    {data && (
                      <DataGrid rows={filteredRows || []} columns={columns}>
                        <SearchState
                          value={searchValue}
                          onValueChange={changeSearchValue}
                        />
                        <PagingState
                          pageSize={apolloArgs.limit}
                          currentPage={apolloArgs.page}
                          onCurrentPageChange={(_currentPage) =>
                            loadMoreRegistrations(
                              _currentPage,
                              refetch,
                              fetchMore
                            )
                          }
                          onPageSizeChange={(_pageSize) =>
                            changePageSize(_pageSize, refetch)
                          }
                        />
                        <CustomPaging
                          totalCount={
                            data?.warranty_registration_aggregate?.aggregate
                              ?.totalCount || 0
                          }
                        />
                        {/* <IntegratedFiltering /> */}
                        {/* <IntegratedPaging /> */}
                        <RowDetailState defaultExpandedRowIds={[0]} />
                        <Table />
                        <TableHeaderRow />
                        <PagingPanel pageSizes={pageSizes} />
                        <TableRowDetail
                          contentComponent={createRowDetail(refetch)}
                        />
                        <Toolbar />
                        {/* <SearchPanel messages={searchMessages} /> */}

                        <Paper className="tableStyles">
                          <div className={classes.header}>
                            <span className={classes.headerTitle}>
                              Warranty Registrations
                            </span>
                            <GridContainer
                              container
                              justify="space-between"
                              className={classes.iconHeaderContainer}
                            >
                              <GridContainer
                                item
                                xs={12}
                                sm={3}
                              ></GridContainer>
                              <GridContainer item xs={12} sm={3}>
                                <CSVLink
                                  data={filteredRows?.map(
                                    (item) => {
                                      const {
                                        profiles,
                                        profile_id,
                                        primary_use,
                                        warranty_id,
                                        submittedon,
                                        id,
                                        is_deleted,
                                        __typename,
                                        ...rest
                                      } = item;
                                      return { ...rest };
                                    }
                                  )}
                                  target="_blank"
                                  filename={"export-warranty-registrations.csv"}
                                >
                                  <Tooltip title="Download To CSV">
                                    <CloudDownloadOutlinedIcon />
                                  </Tooltip>
                                </CSVLink>
                              </GridContainer>

                              <GridContainer item xs={12} sm={3}>
                                <CSVLink
                                  data={
                                    TotalWaranty?.map((item) => {
                                      const { profiles, ...rest } = item;
                                      const Dealer = profiles?.name || "";
                                      return { ...rest, Dealer };
                                    }) || []
                                  }
                                  target="_blank"
                                  filename={"export-warranty-registrations.csv"}
                                >
                                  <Tooltip title="Download All To CSV">
                                    <DownloadIcon />
                                  </Tooltip>
                                </CSVLink>
                              </GridContainer>
                            </GridContainer>
                          </div>
                          {loading ? (
                            <div
                              className="flex center"
                              style={{ padding: "2em 0" }}
                            >
                              <p>Loading...</p>
                              <CircularProgress />
                            </div>
                          ) : (
                            // Uncomment below to enable the data grid
                            // <Grid
                            //   rows={data?.warranty_registration || []}
                            //   columns={columns}
                            // >
                            //   <SearchState
                            //     onValueChange={(value) =>
                            //       this.changeSearchValue(value, refetch)
                            //     }
                            //   />
                            //   <PagingState
                            //     pageSize={apolloArgs.limit}
                            //     currentPage={apolloArgs.page}
                            //     onCurrentPageChange={(currentPage) =>
                            //       this.loadMoreRegistrations(currentPage, refetch, fetchMore)
                            //     }
                            //     onPageSizeChange={(pageSize) =>
                            //       this.changePageSize(pageSize, refetch)
                            //     }
                            //   />
                            //   <CustomPaging
                            //     totalCount={
                            //       data?.warranty_registration_aggregate?.aggregate?.totalCount || 0
                            //     }
                            //   />
                            //   <RowDetailState />
                            //   <Table />
                            //   <TableHeaderRow />
                            //   {/* Optional row detail: Uncomment if needed */}
                            //   {/* <TableRowDetail
                            //     contentComponent={this.createRowDetail(refetch)}
                            //   /> */}
                            //   <PagingPanel pageSizes={pageSizes} />
                            //   <Toolbar />
                            //   <SearchPanel messages={searchMessages} />
                            // </Grid>
                            <></>
                          )}
                        </Paper>
                        <div
                          className={`${
                            selectedField === "Brand" ||
                            selectedField === "Dealer"
                              ? "tableFilter selectbrand"
                              : "tableFilter"
                          }`}
                        >
                          <div className="wrapper">
                            <FieldDropdown
                              fields={columns?.map((column) => column?.title)}
                              selectedField={selectedField}
                              onSelectField={handleFieldChange}
                            />
                            {selectedField === "Dealer" ? (
                              <select
                                value={searchValue}
                                onChange={handleDealerChange}
                                style={{ margin: "0 20px" }}
                              >
                                <option value="">Select Dealer</option>
                                {uniqueDealers.map((dealer) => (
                                  <option key={dealer} value={dealer}>
                                    {dealer}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              <SearchPanel />
                            )}
                          </div>
                        </div>
                      </DataGrid>
                    )}
                  </>
                )}
              </Paper>
            );
          }}
        </Query>
      </div>
    </DashboardLayout>
  );
};

WarrantyRegistrations.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(WarrantyRegistrations);

{
  /* <select
                value={filterBy}
                style={{ padding: "5px 10px", margin: "10px" }}
                onChange={(e) => {
                  setFilterBy(e.target.value);
                  setSearchTerm("");
                  setApolloArgs((prevArgs) => ({
                    ...prevArgs,
                    page: 0,
                    search: "",
                  }));
                }}
              >
                <option value="warranty_id">Warranty ID</option>
                <option value="submittedon">Submitted</option>
                <option value="hull_identification_number">HIN</option>
                <option value="model">Model</option>
                <option value="admin_name">Dealer</option>
                <option value="status">Status</option>
              </select> */
}
{
  /* dropdown */
}
